<template>
  <div class="row" style="padding-bottom: 10px">
    <div class="col-xs-12">
      <table class="table" align="left">
        <tr>
          <th><small>Transaction Id: </small></th>
          <td>{{ transaction.brain_tree_transaction_id }}</td>
        </tr>
        <tr>
          <th><small>Amount: </small></th>
          <td>{{ transaction.transaction_amount | currency }}</td>
        </tr>
        <tr>
          <th><small>Cycle: </small></th>
          <td>{{ transaction.current_billing_cycle }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  filters: {
    currency(amount) {
      return `$${amount.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`;
    },
  },
  props: {
    transaction: {
      required: true,
      type: Object,
    },
  },
};
</script>
